import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import PersonalDetailsForm from "@/components/application/PersonalDetailsForm"
import AppLayout from "@/components/layout/AppLayout"

const PersonalDetailsPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />

        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          Personal Details
        </h1>
        <p className="mb-8 text-center text-gray-600">
          Complete your personal information to finalize your application
        </p>

        <div className="mx-auto max-w-2xl">
          <PersonalDetailsForm />
        </div>
      </div>
    </AppLayout>
  )
}

export default PersonalDetailsPage
